<template>
    <div class="">
        <!-- © {{system_year}} Velocity Vehicle Group. All Rights Reserved.-->
    </div>
</template>
<script>
    import Vue from 'vue';
    import SessioMixin from '../../../../mixins/sessionmixin';
    import EventBus from '../../../event-bus';
    var self;
    export default {
        name: 'Footer',
        mixins: [SessioMixin],
        components: {

        },
        data() {
            return {
                isShowLoggedinfields: '',
                roleId: '',
                userPermissions: '',
                roleName: '',
                system_year: '2018',
            }

        },
        beforeMount: function () {
            self = this;
            var token = localStorage.getItem("api_token");
            if (token != "") {
                self.getUserFromToken(token, 'normal');
            }
        },
        mounted: function () {
            self = this;
        },
        methods: {

        }
    }
    EventBus.$on('role', function (isLogin, id, name, system_year, userPermissions) {
        if (typeof (self) != "undefined") {
            self.isShowLoggedinfields = isLogin;
            self.roleId = id;
            self.userPermissions = userPermissions;
            self.roleName = name;
            self.system_year = system_year;
        }
    });
</script>


// WEBPACK FOOTER //
// src/components/backend/contactextension/print/Footer.vue